import { forwardRef } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconFolderMove = forwardRef((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 16 16"
    data-fill-none
  >
    <path
      d="M15.3334 4.66667C15.3334 3.93027 14.7364 3.33333 14 3.33333H6.00002L5.05777 2.3902C4.80764 2.1402 4.46839 1.99986 4.11471 2H2.00002C1.26363 2 0.666687 2.59694 0.666687 3.33333V12.6667C0.666687 13.4031 1.26363 14 2.00002 14H14C14.7364 14 15.3334 13.4031 15.3334 12.6667V4.66667Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 8.5L10 8.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 8.5L8.5 7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 8.5L8.5 10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
